import Font from '@maxpreps/shared/styles/font';
import styled from 'styled-components';
import { COLOR } from '../../styles/colors';
import Anchor from '../Anchor/Anchor';

const StyledNetworkLinksList = styled.ul`
  display: flex;
  letter-spacing: 2px;

  & > li {
    margin-left: 20px;
    & > a:hover {
      color: ${COLOR.white};
    }
  }
`;

interface ILinkConfig {
  text: string;
  href: string;
}

const NETWORK_LINKS: ILinkConfig[] = [
  {
    text: 'MAXPREPS',
    href: 'https://www.maxpreps.com/'
  },
  {
    text: 'CBSSPORTS.COM',
    href: 'https://www.cbssports.com'
  },
  {
    text: '247SPORTS',
    href: 'https://www.247sports.com'
  }
];

const NetworkLinksList: React.FC = () => (
  <StyledNetworkLinksList className={Font.f11_bold_tall_upper}>
    {NETWORK_LINKS.map(link => {
      const { text, href } = link;
      const isMaxPreps = text.toLowerCase() === 'maxpreps';
      const props = isMaxPreps
        ? {
            $color: COLOR.white
          }
        : {
            $color: `${COLOR.white}7F`, // 50%
            target: '_blank',
            rel: 'noopener noreferrer'
          };

      return (
        <li key={text}>
          <Anchor href={href} {...props}>
            {text}
          </Anchor>
        </li>
      );
    })}
  </StyledNetworkLinksList>
);

export default NetworkLinksList;
